import { createContext, useState } from 'react';

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [adminData, setAdminData] = useState({});

  return (
    <AdminContext.Provider value={{ adminData, setAdminData }}>{children}</AdminContext.Provider>
  );
};
